import TYPES from '../types'

const initState = {
  zoneData: '',
  authenticated: false,
}

const zoneState = (state = initState, action) => {
   
  const { type, data } = action
  switch (type) {
    case TYPES.LOGOUT:
      return { ...initState }
    case TYPES.ALT_zone_DATA:
      return {
        ...state,
        zoneData: data,
      }
    default:
      return state
  }
}

export default zoneState
